import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { getSupabase } from '../lib/supabase'

export default function NameModal() {
  const { user, loading, refreshUser } = useAuth()
  const [nome, setNome] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  if (loading || !user || user.hasFullName) return null

  async function handleSave() {
    const trimmed = nome.trim()
    if (!trimmed) return
    setSaving(true)
    setError('')
    const sb = getSupabase()
    if (!sb) {
      setError('Sem conexão')
      setSaving(false)
      return
    }
    const { error: err } = await sb.auth.updateUser({ data: { full_name: trimmed } })
    if (err) {
      setError('Não foi possível salvar')
      setSaving(false)
      return
    }
    await refreshUser()
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(11,16,16,0.92)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{
        background: 'var(--card)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-card)', padding: 24, maxWidth: 360, width: '100%',
      }}>
        <h2 style={{
          fontFamily: "var(--font-display)", fontSize: 'var(--t-subh)', fontWeight: 500,
          margin: 0, marginBottom: 8, color: 'var(--text)',
        }}>
          Como podemos te chamar?
        </h2>
        <p style={{
          fontSize: 'var(--t-meta)', color: 'var(--txt2)',
          margin: 0, marginBottom: 16, fontFamily: 'var(--font-sans)',
        }}>
          Esse nome aparece no seu Perfil e em emergências.
        </p>
        <input
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          placeholder="Seu nome"
          autoFocus
          onKeyDown={(e) => { if (e.key === 'Enter' && nome.trim() && !saving) handleSave() }}
          style={{
            width: '100%', boxSizing: 'border-box', padding: '12px 14px',
            background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)',
            borderRadius: 8, color: 'var(--text)', fontSize: 'var(--t-base)', outline: 'none',
            marginBottom: 12, fontFamily: 'var(--font-sans)',
          }}
        />
        <button
          onClick={handleSave}
          disabled={saving || !nome.trim()}
          style={{
            width: '100%', padding: '12px 16px',
            borderRadius: 'var(--r-button)', border: 'none',
            background: 'var(--primary)', color: '#0B1010',
            fontFamily: 'var(--font-sans)', fontSize: 'var(--t-base)', fontWeight: 700,
            cursor: (saving || !nome.trim()) ? 'default' : 'pointer',
            opacity: (saving || !nome.trim()) ? 0.4 : 1,
          }}
        >
          {saving ? 'Salvando…' : 'Salvar'}
        </button>
        {error && (
          <div style={{
            color: '#D94040', marginTop: 8, fontSize: 'var(--t-meta)',
            fontFamily: 'var(--font-sans)',
          }}>
            {error}
          </div>
        )}
      </div>
    </div>
  )
}

